module.exports = __webpack_public_path__ + "static/media/subtitle_filter.f7b892c9.svg";